/**
 * Staging's tab shows an amber icon and "Staging ·" in its title, so it's
 * never mistaken for production (the owner, 2026-10-16: "can staging have a
 * different favicon or something added to the current one indicating its not
 * live"). /client-config names the environment; production, CI and local
 * development keep index.html's icons and title.
 */

const STAGING_ICONS: Record<string, string> = {
  "image/svg+xml": "/favicon-staging.svg",
  "image/png": "/favicon-staging-32.png",
};
const STAGING_TITLE = "Staging · ";

export function markEnvironment(environment: string | undefined, doc: Document = document): void {
  if (environment !== "staging") {
    return;
  }
  for (const link of doc.head.querySelectorAll<HTMLLinkElement>('link[rel="icon"]')) {
    const href = STAGING_ICONS[link.type];
    if (href !== undefined) {
      link.setAttribute("href", href);
    }
  }
  if (!doc.title.startsWith(STAGING_TITLE)) {
    doc.title = STAGING_TITLE + doc.title;
  }
}
